/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Report_DoneInputs */

const en_us2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report sent to the club's admins.`)
};

const pt_br2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denúncia enviada aos admins do clube.`)
};

const es_419_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denuncia enviada a los admins del club.`)
};

const pt_pt2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denúncia enviada aos admins do clube.`)
};

const fr_fr2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalement envoyé aux admins du club.`)
};

const de_de2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung an die Admins des Clubs gesendet.`)
};

const it_it2_clubs_report_done = /** @type {(inputs: Clubs_Report_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalazione inviata agli admin del club.`)
};

/**
* | output |
* | --- |
* | "Report sent to the club's admins." |
*
* @param {Clubs_Report_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_report_done = /** @type {((inputs?: Clubs_Report_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Report_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_report_done(inputs)
	if (locale === "es-419") return es_419_clubs_report_done(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_report_done(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_report_done(inputs)
	if (locale === "de-DE") return de_de2_clubs_report_done(inputs)
	if (locale === "it-IT") return it_it2_clubs_report_done(inputs)
	return en_us2_clubs_report_done(inputs)
});
export { clubs_report_done as "clubs.report_done" }